module.exports = __webpack_public_path__ + "img/tu09.19c1b12c.png";